import subscriptions from 'src/js/modules/subscriptions';
import isOnlineStoreTemplate from '../verifiers/is-online-store-template';

const filterAvailableTemplates = (templates, availableSubscriptionTypes, isUserAuthenticated) => {
  const hasEcommerceSubscription = subscriptions.verifiers.hasEcommerceSubscription(
    availableSubscriptionTypes
  );

  if (isUserAuthenticated && !hasEcommerceSubscription) {
    return templates.filter((template) => !isOnlineStoreTemplate(template));
  }

  return templates;
};

export default filterAvailableTemplates;
